import CurrencyIcon from "@mui/icons-material/AttachMoney";

import NitroFilter from "../NitroFilter/index";

const currencies = [
  { label: "USD", value: "USD" },
  { label: "CAD", value: "CAD" },
];

const CurrencyFilterButton = ({
  value,
  setValue,
  isMobile,
}: {
  value: string;
  setValue: (value: string) => void;
  isMobile?: boolean;
}) => {
  return (
    <NitroFilter
      value={value}
      setValue={setValue}
      data={{
        options: currencies,
      }}
      config={{
        disableFilter: true,
      }}
      isMobile={isMobile}
      placeholder="Currency"
      Icon={<CurrencyIcon style={{ color: "#383838" }} />}
    />
  );
};

export default CurrencyFilterButton;
